// TODO: remove
import _ from 'underscore';

const V3_VERSION = '3.0';

function prepareGoogleAccountProperies(model) {
  if (model.ImportAccountUrlOptions) {
    const value = model.TrackingTemplateValue ? decodeURIComponent(model.TrackingTemplateValue) : '';

    const googleAccountProperties = [{
      Key: 'TrackingTemplate',
      Value: value,
    }];
    googleAccountProperties.push({
      Key: 'FinalUrlSuffix',
      Value: model.FinalUrlSuffixValue || '',
    });
    return googleAccountProperties;
  }
  return undefined;
}

function prepareSettingsForTypeFromModel(model, type) {
  const options = [];
  const regexp = new RegExp(`${type}_(.*)`);

  _.each(model, (value, key) => {
    if (value && regexp.test(key)) {
      options.push(key.match(regexp)[1]);
    }
  });

  return options;
}

function processOptions(options) {
  if (options.length === 0) {
    options.push('None');
  }

  return options.join();
}

function prepareNewItemsSetting(model) {
  let options = [];

  if (model.ImportNewEntities) {
    options = prepareSettingsForTypeFromModel(model, 'ImportNewOption');

    // special handling for this option; UI text is opposite of the enum
    // and this is desired behavior, so we pass back the opposite of what
    // is selected in the form
    if (model.ImportNewOption_ImportNewActiveEntitiesOnly) {
      options = _.without(options, 'ImportNewActiveEntitiesOnly');
    } else {
      options.push('ImportNewActiveEntitiesOnly');
    }
  }

  return processOptions(options);
}

function prepareExistingItemsSetting(model) {
  let options = [];

  if (model.UpdateEntityPreferences) {
    options = prepareSettingsForTypeFromModel(model, 'ImportUpdateEntityPreference');
  }


  // special handling for this option; UI text is opposite of the enum
  // and this is desired behavior, so we pass back the opposite of what
  // is selected in the form
  if (model.ImportUpdateEntityPreference_UpdateNameForExistingCampaigns) {
    options = _.without(options, 'UpdateNameForExistingCampaigns');
  } else {
    options.push('UpdateNameForExistingCampaigns');
  }

  return {
    '@odata.type': '#Model.ImportUpdateEntityPreference',
    ImportUpdatedEntities: model.UpdateEntityPreferences,
    ImportUpdateOptions: processOptions(options),
  };
}

function prepareImportAppendDestUrlPreferences(model) {
  return {
    '@odata.type': '#Model.ImportAppendDestUrlPreference',
    UseAppendString: model.ImportAppendDestUrlPreference_UseAppendString,
    AppendStringForDestinationUrl: model.ImportAppendDestUrlPreference_AppendStringForDestinationUrl || '',
  };
}

function prepareImportSearchAndReplaceDestUrlPreferences(model) {
  return {
    '@odata.type': '#Model.ImportSearchAndReplaceDestUrlPreference',
    UseSearchAndReplaceString:
      model.ImportSearchAndReplaceDestUrlPreference_UseSearchAndReplaceString,
    SearchStringForDestinationUrl: model.ImportSearchAndReplaceDestUrlPreference_SearchStringForDestinationUrl || '',
    ReplaceStringForDestinationUrl: model.ImportSearchAndReplaceDestUrlPreference_ReplaceStringForDestinationUrl || '',
  };
}

function prepareSearchAndReplaceTrackingPreferences(model) {
  return {
    '@odata.type': '#Model.SearchAndReplacePreferencesForTrackingTemplate',
    UseSearchAndReplaceString:
      model.SearchAndReplacePreferencesForTrackingTemplate_UseSearchAndReplaceString,
    SearchStringForTrackingTemplate: model.SearchAndReplacePreferencesForTrackingTemplate_SearchStringForTrackingTemplate || '',
    ReplaceStringForTrackingTemplate: model.SearchAndReplacePreferencesForTrackingTemplate_ReplaceStringForTrackingTemplate || '',
  };
}

function prepareSearchAndReplaceCustomParameters(model) {
  return {
    '@odata.type': '#Model.ImportSearchAndReplaceForStringProperty',
    EnableSearchAndReplace:
      model.SearchAndReplaceForCustomParameters_EnableSearchAndReplace,
    SearchString: model.SearchAndReplaceForCustomParameters_SearchString || '',
    ReplaceString: model.SearchAndReplaceForCustomParameters_ReplaceString || '',
    IgnoreCaseInPlainText: true, // always set to true since we don't expose this option to customer
  };
}

function prepareAppendCustomParameterPrefererences(model) {
  return {
    '@odata.type': '#Model.AppendPreferencesForCustomParameter',
    UseAppendString: model.AppendPreferencesForCustomParameter_UseAppendString,
    AppendStringForCustomParameter: model.AppendPreferencesForCustomParameter_AppendStringForCustomParameter || '',
  };
}

function prepareFindAndReplaceURLSuffixPreference(model) {
  return {
    '@odata.type': '#Model.ImportSearchAndReplaceForStringProperty',
    EnableSearchAndReplace:
      model.SearchAndReplaceForFinalURLSuffix_EnableSearchAndReplace,
    SearchString: model.SearchAndReplaceForFinalURLSuffix_SearchString || '',
    ReplaceString: model.SearchAndReplaceForFinalURLSuffix_ReplaceString || '',
    IgnoreCaseInPlainText: true, // always set to true since we don't expose this option to customer
  };
}
function prepareAppendFinalRULSuffixPrefererence(model) {
  return {
    '@odata.type': '#Model.AppendPreferencesForFinalURLSuffix',
    UseAppendString: model.AppendPreferencesForFinalURLSuffix_UseAppendString,
    AppendStringForFinalURLSuffix: model.AppendPreferencesForFinalURLSuffix_AppendStringForFinalURLSuffix || '',
  };
}


function prepareAppendTrackingPreferences(model) {
  return {
    '@odata.type': '#Model.AppendPreferencesForTrackingTemplate',
    UseAppendString: model.AppendPreferencesForTrackingTemplate_UseAppendString,
    AppendStringForTrackingTemplate: model.AppendPreferencesForTrackingTemplate_AppendStringForTrackingTemplate || '',
  };
}

function prepareCampaignNameSuffixPreferences(model) {
  return {
    '@odata.type': '#Model.ImportPrefixAndSuffixForStringProperty',
    EnablePrefixAndSuffix: model.ImportPrefixAndSuffixForStringProperty_EnablePrefixAndSuffix,
    SuffixString: model.ImportPrefixAndSuffixForStringProperty_SuffixString || '',
  };
}

function prepareSearchAndReplaceCampaignNamePreferences(model) {
  return {
    '@odata.type': '#Model.ImportSearchAndReplaceForStringProperty',
    EnableSearchAndReplace: model.ImportSearchAndReplaceForStringProperty_EnableSearchAndReplace,
    SearchString: model.ImportSearchAndReplaceForStringProperty_SearchString || '',
    ReplaceString: model.ImportSearchAndReplaceForStringProperty_ReplaceString || '',
    IgnoreCaseInPlainText: true, // always set to true since we don't expose this option to customer
  };
}

function prepareBMCSetting(model) {
  const flag = model.StoreIdForImportedProductAdExtensionsFlag;
  const id = parseInt(model.StoreIdForImportedProductAdExtensions, 10);

  if (flag && !_.isNaN(id)) {
    return id;
  }
  return null;
}

function prepareNumericAdjustmentSetting(model, propertyName) {
  let adjustValue = model[`${propertyName}_AdjustmentValue`];

  if (_.isString(adjustValue)) {
    if (adjustValue.indexOf(',') >= 0) {
      adjustValue = adjustValue.replace(',', '.');
    }
    if (adjustValue.indexOf('.') >= 0 || adjustValue.indexOf(',') >= 0) {
      adjustValue = parseFloat(adjustValue);
    } else {
      adjustValue = parseInt(adjustValue, 10);
    }
  }

  if (model[`${propertyName}_AdjustmentDecrease`]) {
    adjustValue *= -1;
  }

  return {
    '@odata.type': '#Model.ImportAdjustmentForNumericProperty',
    EnableAdjustment: model[`${propertyName}_EnableAdjustment`],
    AdjustmentValue:
      model[`${propertyName}_EnableAdjustment`] ? adjustValue : null,
  };
}

export function parseModelToImportUserPreferences(model) {
  const preferences = {
    '@odata.type': '#Model.ImportUserPreferences',
    ImportNewEntities: model.ImportNewEntities,
    ImportNewOptions: prepareNewItemsSetting(model),
    UpdateEntityPreferences: prepareExistingItemsSetting(model),
    ImportDeletedEntities: model.ImportDeletedEntities,
    DefaultBidsBelowMinToAdCenterMinBid: model.DefaultBidsBelowMinToAdCenterMinBid,
    DefaultCampaignBudgetBelowMinToAdCenterMinBudget:
      model.DefaultCampaignBudgetBelowMinToAdCenterMinBudget,
    AppendDestUrlPreference: prepareImportAppendDestUrlPreferences(model),
    SearcAndReplaceDestUrlPreference: prepareImportSearchAndReplaceDestUrlPreferences(model),
    AppendTrackingTemplatePreference: prepareAppendTrackingPreferences(model),
    SearchAndReplaceTrackingTemplatePreference: prepareSearchAndReplaceTrackingPreferences(model),
    AppendCustomParameterPreferences: prepareAppendCustomParameterPrefererences(model),
    AppendFinalURLSuffixPreferences: prepareAppendFinalRULSuffixPrefererence(model),
    ImportAdExtensionsAsLibrary: 'true',
    StoreIdForImportedProductAdExtensions: prepareBMCSetting(model),
    UserSetProperties2: prepareGoogleAccountProperies(model),
  };

  preferences.PrefixAndSuffixForCampaignNames = prepareCampaignNameSuffixPreferences(model);
  preferences.SearchAndReplaceForCampaignNames =
    prepareSearchAndReplaceCampaignNamePreferences(model);

  preferences.RaiseLowBidsToMinServingBidsForBsc = model.RaiseLowBidsToMinServingBidsForBsc;

  preferences.ImportSearchAndDsaMixedCampaignAsSearchCampaign =
    model.ImportSearchAndDsaMixedCampaignAsSearchCampaign;

  preferences.AdjustmentForBids = prepareNumericAdjustmentSetting(model, 'AdjustmentForBids');
  preferences.AdjustmentForCampaignBudgets =
    prepareNumericAdjustmentSetting(model, 'AdjustmentForCampaignBudgets');
  preferences.PauseParentIfNoLocationSupported = model.PauseParentIfNoLocationSupported;
  preferences.EnableParentLocationMapping = !model.EnableParentLocationMapping;
  preferences.Version = V3_VERSION;

  preferences.ImportNewLabelsAndAssociations = (model.ImportNewLabelsAndAssociations != null)
    ? model.ImportNewLabelsAndAssociations
    : model.ImportNewEntities;
  preferences.UpdateLabelsAndAssociations = (model.UpdateLabelsAndAssociations != null)
    ? model.UpdateLabelsAndAssociations
    : model.ImportUpdatedEntities;
  preferences.ImportNewCustomFiltersForShoppingCampaigns =
    (model.ImportNewCustomFiltersForShoppingCampaigns != null)
      ? model.ImportNewCustomFiltersForShoppingCampaigns
      : model.ImportNewEntities;
  preferences.UpdateCustomFiltersForShoppingCampaigns =
    (model.UpdateCustomFiltersForShoppingCampaigns != null)
      ? model.UpdateCustomFiltersForShoppingCampaigns
      : model.ImportUpdatedEntities;

  preferences.AssociatedUETTagId = (model.ImportNewOption_ImportNewAudienceTargets &&
    model.AssociatedUETTagId &&
    model.AssociatedUETTagId !== '-1' && !!model.ImportUET
    && !!model.ImportNewEntities) ? Number(model.AssociatedUETTagId) : null;

  preferences.SearchAndReplaceForCustomParameters
    = prepareSearchAndReplaceCustomParameters(model);

  preferences.SearchAndReplaceForFinalURLSuffix
    = prepareFindAndReplaceURLSuffixPreference(model);

  if (!_.isUndefined(model.PauseAdGroupIfNoLocationSupported)
    && !_.isNull(model.PauseAdGroupIfNoLocationSupported)) {
    preferences.PauseAdGroupIfNoLocationSupported = model.PauseAdGroupIfNoLocationSupported;
  }

  if (!_.isUndefined(model.NoAudienceTargetForFBImportOption)
    && !_.isNull(model.NoAudienceTargetForFBImportOption)) {
    preferences.ImportNewAudienceTargets = !model.NoAudienceTargetForFBImportOption;
    preferences.UpdateAudienceTargets = !model.NoAudienceTargetForFBImportOption;
  }

  if (!_.isUndefined(model.EnableAutoCurrencyConversion)
    && !_.isNull(model.EnableAutoCurrencyConversion)) {
    preferences.EnableAutoCurrencyConversion = model.EnableAutoCurrencyConversion;
  }

  return preferences;
}
